import AltInstance from '../Globals/Scripts/AltInstance';

class NotificationActions {
    constructor() {
        this.generateActions(
            'notificationReceived',
            'clearNotifications');
    }
}

export default AltInstance.createActions(NotificationActions);
